import React, { useState } from "react";
import {
  AppstoreOutlined,
  HomeOutlined,
  SettingOutlined,
  UserOutlined,
  DollarCircleOutlined,
  ThunderboltOutlined,
  ControlOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Menu, Button } from "antd";
import ListUser from "./ManageUser/ListUser";
import "./Admin.css";

type MenuItem = Required<MenuProps>["items"][number];

const items: MenuItem[] = [
  {
    key: "1",
    icon: <HomeOutlined />,
    label: "Trang chủ",
  },
  {
    key: "2",
    icon: <UserOutlined />,
    label: "Quản lý User",
    children: [{ key: "11", label: "Danh sách User" }],
  },
];

interface LevelKeysProps {
  key?: string;
  children?: LevelKeysProps[];
}

const getLevelKeys = (items1: LevelKeysProps[]) => {
  const key: Record<string, number> = {};
  const func = (items2: LevelKeysProps[], level = 1) => {
    items2.forEach((item) => {
      if (item.key) {
        key[item.key] = level;
      }
      if (item.children) {
        func(item.children, level + 1);
      }
    });
  };
  func(items1);
  return key;
};

const levelKeys = getLevelKeys(items as LevelKeysProps[]);

const DashboardHome = ({ onNavigateUser }: { onNavigateUser: () => void }) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="admin-card">
        <div className="admin-card__title">
          <span className="admin-card__title-dot" />
          TỔNG QUAN HỆ THỐNG
        </div>

        <div className="admin-stats-grid">
          <div className="admin-stat-card">
            <div className="admin-stat-card__icon admin-stat-card__icon--blue">
              <UserOutlined />
            </div>
            <div>
              <div className="admin-stat-card__label">Tổng Người Dùng</div>
              <div className="admin-stat-card__value">1,280</div>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="admin-stat-card__icon admin-stat-card__icon--gold">
              <DollarCircleOutlined />
            </div>
            <div>
              <div className="admin-stat-card__label">Tổng Số Xu Hệ Thống</div>
              <div className="admin-stat-card__value">9,850,000</div>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="admin-stat-card__icon admin-stat-card__icon--emerald">
              <AppstoreOutlined />
            </div>
            <div>
              <div className="admin-stat-card__label">Sảnh Game Hoạt Động</div>
              <div className="admin-stat-card__value" style={{ color: "#00FF88" }}>
                ONLINE (12)
              </div>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="admin-stat-card__icon admin-stat-card__icon--purple">
              <ThunderboltOutlined />
            </div>
            <div>
              <div className="admin-stat-card__label">Độ Trễ AI Hack</div>
              <div className="admin-stat-card__value" style={{ color: "#00E5FF" }}>
                14ms
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card__title">
          <span className="admin-card__title-dot" />
          LẮT CẮT THAO TÁC NHANH
        </div>
        <div className="flex flex-wrap gap-4">
          <Button type="primary" className="btn-admin-primary" onClick={onNavigateUser}>
            <UserOutlined /> Quản lý danh sách User
          </Button>
        </div>
      </div>
    </div>
  );
};

const MenuAdmin: React.FC = () => {
  const [stateOpenKeys, setStateOpenKeys] = useState(["2"]);
  const [selectedKey, setSelectedKey] = useState("1");

  const onSelect: MenuProps["onSelect"] = ({ key }) => {
    setSelectedKey(key);
  };

  const renderContent = () => {
    switch (selectedKey) {
      case "1":
        return <DashboardHome onNavigateUser={() => setSelectedKey("11")} />;
      case "11":
        return <ListUser />;
      default:
        return <DashboardHome onNavigateUser={() => setSelectedKey("11")} />;
    }
  };

  const onOpenChange: MenuProps["onOpenChange"] = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);

      setStateOpenKeys(
        openKeys
          .filter((_, index) => index !== repeatIndex)
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      setStateOpenKeys(openKeys);
    }
  };

  return (
    <div className="flex w-full" style={{ minHeight: "calc(100vh - 64px)" }}>
      <div className="admin-sidebar">
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          openKeys={stateOpenKeys}
          onOpenChange={onOpenChange}
          onSelect={onSelect}
          items={items}
        />
      </div>
      <div className="admin-content">{renderContent()}</div>
    </div>
  );
};

export default MenuAdmin;
